import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RegistrationApiGet} from "./reg_api";

type RegState = {
    current: RegistrationApiGet | undefined
    scancode: string,
    selectedPO: number
    saving: boolean
}


const initialState: RegState = {
    current: undefined,
    scancode: "",
    selectedPO: 0,
    saving: false
}

const sessionSlice = createSlice({
    name: "reg",
    initialState,
    reducers: {
        current: function (state: RegState, action: PayloadAction<RegistrationApiGet | undefined>) {
            state.current = action.payload;
        },
        addScanChar: function (state: RegState, action: PayloadAction<string>) {
            state.scancode = state.scancode + action.payload
        },
        setScanCode: function (state: RegState, action: PayloadAction<string>) {
            state.scancode = action.payload
        },
        processScan: function (state, action: PayloadAction<number>) {
        },
        clearScancode: function (state: RegState) {
            state.scancode = ""
        },
        resetReg: function (state) {
            state.saving = false;
        }

    },
});

export const {
    current,
    processScan,
    clearScancode,
    addScanChar,
    setScanCode,
    resetReg,
} = sessionSlice.actions
export const reducer = sessionSlice.reducer;




